import {AbstractControl, ValidatorFn, FormControl} from '@angular/forms';

export function regExpValidator(re: RegExp): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    const result = re.test(control.value);
    return !result && control.value && control.value.length ? {'regexp': {value: control.value}} : null;
  };
}

export function existsInArrayString(values: string[]) {
  return (control: FormControl) => {
    return values.length ? values.map(x => x.toUpperCase()).indexOf(control.value.toString().toUpperCase()) > -1 ? {existsInArray: true} : null : null;
  };
}

export function trimValidString() {
  return (control: FormControl) => {
    return control.value ? control.value.length ? control.value.trim().length ? null : {trimValidString: true} : null : null;
  };
}

/* Ejemplo de validacion asincronica (se debe usar un pipe para angular 6+)
export const codigoEntidadAsyncValidator = (service: FinancieraService, time: number = 500) => {
  return (input: FormControl) => {
    return Observable.timer(time).switchMap(() => service.codigoEntidadExists(input.value)).map(res => {
        return res ? {codigoExists: true} : null;
      });
  };
};*/



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/validators/CustomValidators.ts